import { CoachingCenterWaiverContent } from 'components/waivers/cc-waiver'
import { WaiverWrapper } from '../styles'
import React from 'react'
import CoachingCenterAgreeSection from 'components/waivers/cc-agree-section'

const ReservationsWaiver = ({ showWaiver, form, stripePaymentFormRef }) => {
  const onSubmit = async () => {
    if (stripePaymentFormRef.current?.submitPayment) {
      return stripePaymentFormRef.current.submitPayment()
    }
  }

  const handleClick = async () => {
    await form.handleSubmit(onSubmit)()
  }

  return (
    <WaiverWrapper showWaiver={showWaiver}>
      <CoachingCenterWaiverContent showHeader={false} />
      <CoachingCenterAgreeSection form={form} handleClick={handleClick} />
    </WaiverWrapper>
  )
}

export default ReservationsWaiver
